import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/financial/aiasReportActions'
import * as api from '../../../api/reports/financial/aiasReport'

function* aiasReportActionsReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.AIAS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AIAS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* aiasReportActionsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({ type: constants.AIAS_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AIAS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* aiasReportActionsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.AIAS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AIAS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchAiasReportGetJobList() {
  yield takeLatest(constants.AIAS_REPORT_GET_JOB_LIST.ACTION, aiasReportActionsReportGetJobList)
}

function* watchAiasReportGetOrganizationList() {
  yield takeLatest(
    constants.AIAS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    aiasReportActionsReportGetOrganizationList
  )
}

function* watchAiasReportGetFullReport() {
  yield takeLatest(
    constants.AIAS_REPORT_GET_FULL_REPORT.ACTION,
    aiasReportActionsReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchAiasReportGetJobList),
    fork(watchAiasReportGetOrganizationList),
    fork(watchAiasReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/financial/aiasReportSaga.js